import { Api } from '../../Api';
import { IUser } from '../../models';

class AuthApi {

  /**
   * Obtains current user record from back end. The Keycloak JWT in the
   * Authorization header is validated by the Laravel keycloak guard, which
   * firstOrCreates the user by email.
   */
  static me = async (): Promise<IUser> => {
    return Api.Get<IUser>(`api/me`);
  }

  /**
   * Change the authenticated user's password. The backend uses the
   * Keycloak admin client to set the new password directly — no
   * current-password verification (the JWT already proves identity).
   */
  static changePassword = async (newPassword: string, signal?: AbortSignal): Promise<void> => {
    await Api.Post<void>(`api/password/change`, { new: newPassword }, signal);
  }

}

export { AuthApi }
